import { useEffect, useState } from "react"
import Spinner from "../../components/Spinner";
import { IoChevronForward, IoCloseCircle, IoReload } from "react-icons/io5";
import Wrapper from "./Wrapper";
import { message, PermiteSoloNumeros } from "../../utils/Funciones";
import { useDispatch, useSelector } from "react-redux";
import ImagesPreviewBanner2 from "../../components/ImagesPreviewBanner2";
import { SET_TO_DEFAULT_RESPONSE, updateConfiguration } from "../../store/features/slices/userSlice";
import { Button, FormControl, IconButton, MenuItem, Select, Tooltip } from "@mui/material";
import Socket, { authSocket, logoutSocket } from '../../utils/Socket';
import { LazyLoadImage } from "react-lazy-load-image-component";
import { MuiTelInput } from "mui-tel-input";
import Switch from "../../components/switch";
import { FaPlus } from "react-icons/fa";
import { v4 as uuidv4 } from 'uuid';
import { convertFromRaw, convertToRaw, EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { FaUpload } from "react-icons/fa6";
import WhatsAppQRCode from "../../components/WhatsAppQRCode";

const WhatsAppBot = ({ socket }) => {
    const dispatch = useDispatch();
    const { isMutation, configuration: configurations } = useSelector((state) => state.userReducer);
    const { isMutation: isMutationCategories, subcategories } = useSelector((state) => state.categoryReducer);
    const [section, setSection] = useState('sistema')
    const [yapeEditor, setYapeEditor] = useState(
        () => EditorState.createEmpty(),
    );
    const [plinEditor, setPlinEditor] = useState(
        () => EditorState.createEmpty(),
    );
    const [pagomovilEditor, setPagoMovilEditor] = useState(
        () => EditorState.createEmpty(),
    );
    const [nequiEditor, setNequiEditor] = useState(
        () => EditorState.createEmpty(),
    );
    const [banamexEditor, setBanamexEditor] = useState(
        () => EditorState.createEmpty(),
    );
    const [yolopagoEditor, setYoloPagoEditor] = useState(
        () => EditorState.createEmpty(),
    );
    const [tigomoneyEditor, setTigoMoneyEditor] = useState(
        () => EditorState.createEmpty(),
    );
    const [yastaEditor, setYastaEditor] = useState(
        () => EditorState.createEmpty(),
    );
    const [transferenciaEditor, setTransferenciaEditor] = useState(
        () => EditorState.createEmpty(),
    );
    const [spinEditor, setSpinEditor] = useState(
        () => EditorState.createEmpty(),
    );
    const [cashappEditor, setCashAppEditor] = useState(
        () => EditorState.createEmpty(),
    );
    const [venmoEditor, setVenmoEditor] = useState(
        () => EditorState.createEmpty(),
    );
    const [zelleEditor, setZelleEditor] = useState(
        () => EditorState.createEmpty(),
    );
    const [izipayEditor, setIziPayEditor] = useState(
        () => EditorState.createEmpty(),
    );
    const [mercadopagoEditor, setMercadoPagoEditor] = useState(
        () => EditorState.createEmpty(),
    );
    const [binanceEditor, setBinanceEditor] = useState(
        () => EditorState.createEmpty(),
    );
    const [paypalEditor, setPaypalEditor] = useState(
        () => EditorState.createEmpty(),
    );
    const [stripeEditor, setStripeEditor] = useState(
        () => EditorState.createEmpty(),
    );

    const [configuration, setConfiguration] = useState({
        _id: "",
        appKey: "",
        name: "",
        logo: "",
        slider1: '',
        slider2: '',
        slider3: '',
        slider4: '',
        slider5: '',

        qryape: '',
        qrplin: '',
        qrpagomovil: '',
        qrbanamex: '',
        qrnequi: '',
        qryolopago: '',
        qrtigomoney: '',
        qryasta: '',
        qrtransferencia: '',
        qrspin: '',
        qrcashapp: '',
        qrvenmo: '',
        qrzelle: '',
        qrizipay: '',
        qrmercadopago: '',
        qrbinance: '',
        qrpaypal: '',
        qrstripe: '',

        login: false,
        register: false,
        buyservice: false,
        buycredits: false,
        changepassword: false,
        changeavatar: false,
        maintenance: false,
        howmuchforreseller: 0,
        howmuchtimeforeditpassworddays: 0,
        canrecoverpassword: false,
        sliders: [],
        autodeleteusers: {
            autodelete: true,
            days: 15
        },
        autodeleteventas: {
            autodelete: true,
            days: 30,
            targetIds: []
        },
        autodeletecuentas: {
            autodelete: true,
            days: 30,
            targetIds: []
        },
        social: {
            email: "",
            facebook: "",
            tiktok: "",
            instagram: "",
            telegram: "",
            youtube: "",
            whatsapp: "",
            location: ""
        },
        vip: {
            vip1: {
                price: 12,
                enabled: true,
                eslogan: "",
                namefeature: "",
                features: []
            },
            vip2: {
                price: 60,
                enabled: true,
                eslogan: "",
                namefeature: "",
                features: []
            },
            vip3: {
                price: 100,
                enabled: true,
                eslogan: "",
                namefeature: "",
                features: []
            }
        },
        pasarelas: {
            yape: { "enabled": true, "auto": false, "accountdata": { "qr": "", "data": '{"blocks":[{"key":"9vldl","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}' } },
            plin: { "enabled": true, "auto": false, "accountdata": { "qr": "", "data": '{"blocks":[{"key":"9vldl","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}' } },
            pagomovil: { "enabled": true, "auto": false, "accountdata": { "qr": "", "data": '{"blocks":[{"key":"9vldl","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}' } },
            nequi: { "enabled": true, "auto": false, "accountdata": { "qr": "", "data": '{"blocks":[{"key":"9vldl","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}' } },
            banamex: { "enabled": true, "auto": false, "accountdata": { "qr": "", "data": '{"blocks":[{"key":"9vldl","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}' } },
            yolopago: { "enabled": true, "auto": false, "accountdata": { "qr": "", "data": '{"blocks":[{"key":"9vldl","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}' } },
            tigomoney: { "enabled": true, "auto": false, "accountdata": { "qr": "", "data": '{"blocks":[{"key":"9vldl","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}' } },
            yasta: { "enabled": true, "auto": false, "accountdata": { "qr": "", "data": '{"blocks":[{"key":"9vldl","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}' } },
            transferencia: { "enabled": true, "auto": false, "accountdata": { "qr": "", "data": '{"blocks":[{"key":"9vldl","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}' } },
            spin: { "enabled": true, "auto": false, "accountdata": { "qr": "", "data": '{"blocks":[{"key":"9vldl","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}' } },
            cashapp: { "enabled": true, "auto": false, "accountdata": { "qr": "", "data": '{"blocks":[{"key":"9vldl","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}' } },
            venmo: { "enabled": true, "auto": false, "accountdata": { "qr": "", "data": '{"blocks":[{"key":"9vldl","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}' } },
            zelle: { "enabled": true, "auto": false, "accountdata": { "qr": "", "data": '{"blocks":[{"key":"9vldl","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}' } },
            izipay: {
                "enabled": true, "auto": true, "accountdata": {
                    "qr": "", "data": '{"blocks":[{"key":"9vldl","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
                    public_key: "", id_tienda: "", clave: "", password: "", clave_hmac_sha_256: ""
                }
            },
            mercadopago: {
                "enabled": true, "auto": true, "accountdata": {
                    "qr": "", "data": '{"blocks":[{"key":"9vldl","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
                    api_key: "", secret_key: ""
                }
            },
            binance: {
                "enabled": true, "auto": true, "accountdata": {
                    "qr": "", "data": '{"blocks":[{"key":"9vldl","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
                    api_key: "", api_secret: "", merchant_id: ""
                }
            },
            paypal: {
                "enabled": true, "auto": true, "accountdata": {
                    "qr": "", "data": '{"blocks":[{"key":"9vldl","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
                    client_id: "", client_secret: ""
                }
            },
            stripe: {
                "enabled": false, "auto": false, "accountdata": {
                    "qr": "", "data": '{"blocks":[{"key":"9vldl","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
                    api_key: "", secret_key: ""
                }
            }
        }

    })

    useEffect(() => {
        setConfiguration({
            ...configuration,
            _id: configurations._id,
            appKey: configurations.appKey,
            name: configurations.name,
            logo: configurations.logo,
            slider1: configurations.sliders[0]?.url,
            slider2: configurations.sliders[1]?.url,
            slider3: configurations.sliders[2]?.url,
            slider4: configurations.sliders[3]?.url,
            slider5: configurations.sliders[4]?.url,
            login: configurations.login,
            register: configurations.register,
            buyservice: configurations.buyservice,
            buycredits: configurations.buycredits,
            changepassword: configurations.changepassword,
            changeavatar: configurations.changeavatar,
            maintenance: configurations.maintenance,
            howmuchforreseller: configurations.howmuchforreseller,
            howmuchtimeforeditpassworddays: configurations.howmuchtimeforeditpassworddays,
            canrecoverpassword: configurations.canrecoverpassword,
            sliders: configurations.sliders,
            autodeleteusers: configurations?.autodeleteusers,
            autodeleteventas: configurations?.autodeleteventas,
            autodeletecuentas: configurations?.autodeletecuentas,
            social: configurations?.social,
            pasarelas: configurations?.pasarelas,
            vip: {
                vip1: {
                    price: configurations?.vip?.vip1?.price,
                    enabled: configurations?.vip?.vip1?.enabled,
                    eslogan: configurations?.vip?.vip1?.eslogan,
                    namefeature: "",
                    features: configurations?.vip?.vip1?.features || []
                },
                vip2: {
                    price: configurations?.vip?.vip2?.price,
                    enabled: configurations?.vip?.vip2?.enabled,
                    eslogan: configurations?.vip?.vip2?.eslogan,
                    namefeature: "",
                    features: configurations?.vip?.vip2?.features || []
                },
                vip3: {
                    price: configurations?.vip?.vip3?.price,
                    enabled: configurations?.vip?.vip3?.enabled,
                    eslogan: configurations?.vip?.vip3?.eslogan,
                    namefeature: "",
                    features: configurations?.vip?.vip3?.features || []
                }
            }
        })
        if (!isMutation.loading && configurations?.pasarelas !== undefined) {
            // YAPE
            const rawContentYape = configurations?.pasarelas?.yape?.accountdata?.data;
            const contentStateYape = convertFromRaw(JSON.parse(rawContentYape));
            const editorStateYape = EditorState.createWithContent(contentStateYape);
            setYapeEditor(editorStateYape)
            // YAPE
            const rawContentPlin = configurations?.pasarelas?.plin?.accountdata?.data;
            const contentStatePlin = convertFromRaw(JSON.parse(rawContentPlin));
            const editorStatePlin = EditorState.createWithContent(contentStatePlin);
            setPlinEditor(editorStatePlin)
            // PAGOMOVIL
            const rawContentPagomovil = configurations?.pasarelas?.pagomovil?.accountdata?.data;
            const contentStatePagomovil = convertFromRaw(JSON.parse(rawContentPagomovil));
            const editorStatePagomovil = EditorState.createWithContent(contentStatePagomovil);
            setPagoMovilEditor(editorStatePagomovil)
            // NEQUI
            const rawContentNequi = configurations?.pasarelas?.nequi?.accountdata?.data;
            const contentStateNequi = convertFromRaw(JSON.parse(rawContentNequi));
            const editorStateNequi = EditorState.createWithContent(contentStateNequi);
            setNequiEditor(editorStateNequi)

            const rawContentBanamex = configurations?.pasarelas?.banamex?.accountdata?.data;
            const contentStateBanamex = convertFromRaw(JSON.parse(rawContentBanamex));
            const editorStateBanamex = EditorState.createWithContent(contentStateBanamex);
            setBanamexEditor(editorStateBanamex);

            const rawContentYolopago = configurations?.pasarelas?.yolopago?.accountdata?.data;
            const contentStateYolopago = convertFromRaw(JSON.parse(rawContentYolopago));
            const editorStateYolopago = EditorState.createWithContent(contentStateYolopago);
            setYoloPagoEditor(editorStateYolopago);

            const rawContentTigomoney = configurations?.pasarelas?.tigomoney?.accountdata?.data;
            const contentStateTigomoney = convertFromRaw(JSON.parse(rawContentTigomoney));
            const editorStateTigomoney = EditorState.createWithContent(contentStateTigomoney);
            setTigoMoneyEditor(editorStateTigomoney);

            const rawContentYasta = configurations?.pasarelas?.yasta?.accountdata?.data;
            const contentStateYasta = convertFromRaw(JSON.parse(rawContentYasta));
            const editorStateYasta = EditorState.createWithContent(contentStateYasta);
            setYastaEditor(editorStateYasta);

            const rawContentTransferencia = configurations?.pasarelas?.transferencia?.accountdata?.data;
            const contentStateTransferencia = convertFromRaw(JSON.parse(rawContentTransferencia));
            const editorStateTransferencia = EditorState.createWithContent(contentStateTransferencia);
            setTransferenciaEditor(editorStateTransferencia);

            const rawContentSpin = configurations?.pasarelas?.spin?.accountdata?.data;
            const contentStateSpin = convertFromRaw(JSON.parse(rawContentSpin));
            const editorStateSpin = EditorState.createWithContent(contentStateSpin);
            setSpinEditor(editorStateSpin);

            const rawContentCashapp = configurations?.pasarelas?.cashapp?.accountdata?.data;
            const contentStateCashapp = convertFromRaw(JSON.parse(rawContentCashapp));
            const editorStateCashapp = EditorState.createWithContent(contentStateCashapp);
            setCashAppEditor(editorStateCashapp);

            const rawContentVenmo = configurations?.pasarelas?.venmo?.accountdata?.data;
            const contentStateVenmo = convertFromRaw(JSON.parse(rawContentVenmo));
            const editorStateVenmo = EditorState.createWithContent(contentStateVenmo);
            setVenmoEditor(editorStateVenmo);

            const rawContentZelle = configurations?.pasarelas?.zelle?.accountdata?.data;
            const contentStateZelle = convertFromRaw(JSON.parse(rawContentZelle));
            const editorStateZelle = EditorState.createWithContent(contentStateZelle);
            setZelleEditor(editorStateZelle);

            const rawContentIzipay = configurations?.pasarelas?.izipay?.accountdata?.data;
            const contentStateIzipay = convertFromRaw(JSON.parse(rawContentIzipay));
            const editorStateIzipay = EditorState.createWithContent(contentStateIzipay);
            setIziPayEditor(editorStateIzipay);

            const rawContentMercadopago = configurations?.pasarelas?.mercadopago?.accountdata?.data;
            const contentStateMercadopago = convertFromRaw(JSON.parse(rawContentMercadopago));
            const editorStateMercadopago = EditorState.createWithContent(contentStateMercadopago);
            setMercadoPagoEditor(editorStateMercadopago);

            const rawContentBinance = configurations?.pasarelas?.binance?.accountdata?.data;
            const contentStateBinance = convertFromRaw(JSON.parse(rawContentBinance));
            const editorStateBinance = EditorState.createWithContent(contentStateBinance);
            setBinanceEditor(editorStateBinance);

            const rawContentPaypal = configurations?.pasarelas?.paypal?.accountdata?.data;
            const contentStatePaypal = convertFromRaw(JSON.parse(rawContentPaypal));
            const editorStatePaypal = EditorState.createWithContent(contentStatePaypal);
            setPaypalEditor(editorStatePaypal);

            const rawContentStripe = configurations?.pasarelas?.stripe?.accountdata?.data;
            const contentStateStripe = convertFromRaw(JSON.parse(rawContentStripe));
            const editorStateStripe = EditorState.createWithContent(contentStateStripe);
            setStripeEditor(editorStateStripe);

        }
    }, [configurations], [configurations?.pasarelas])

    const onChangeHandle = (e) => {
        setConfiguration({ ...configuration, [e.target.name]: e.target.value })
    }

    const [preview, setPreview] = useState({
        logo: '',
        slider1: '',
        slider2: '',
        slider3: '',
        slider4: '',
        slider5: '',
        qryape: '',
        qrplin: '',
        qrpagomovil: '',
        qrbanamex: '',
        qrnequi: '',
        qryolopago: '',
        qrtigomoney: '',
        qryasta: '',
        qrtransferencia: '',
        qrspin: '',
        qrcashapp: '',
        qrvenmo: '',
        qrzelle: '',
        qrizipay: '',
        qrbinance: '',
        qrmercadopago: '',
        qrpaypal: '',
        qrstripe: '',
    })

    const imageHandle = e => {
        if (e.target.files.length !== 0) {
            setConfiguration({ ...configuration, [e.target.name]: e.target.files[0] });
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview({ ...preview, [e.target.name]: reader.result })
            }
            reader.readAsDataURL(e.target.files[0]);
        }
    }

    const onSubmitUpdateConfiguration = (e) => {
        e.preventDefault();
        const errors = []
        if (configuration.name.trim().length < 1) {
            errors.push({ message: `nombre de la empresa es requerido` })
        }

        if (configuration.howmuchforreseller.toString().trim().length < 1) {
            errors.push({ message: `créditos mínimos para reseller es requerido` })
        }

        if (configuration.howmuchtimeforeditpassworddays.toString().trim().length < 1) {
            errors.push({ message: `días para poder restablecer la contraseña es requerido` })
        }

        if (errors.length === 0) {
            const configcurrent = {
                _id: configurations._id,
                appKey: configurations.appKey,
                name: configurations.name,
                logo: configurations.logo,
                slider1: configurations.sliders[0]?.url,
                slider2: configurations.sliders[1]?.url,
                slider3: configurations.sliders[2]?.url,
                slider4: configurations.sliders[3]?.url,
                slider5: configurations.sliders[4]?.url,
                login: configurations.login,
                register: configurations.register,
                buyservice: configurations.buyservice,
                buycredits: configurations.buycredits,
                changepassword: configurations.changepassword,
                changeavatar: configurations.changeavatar,
                maintenance: configurations.maintenance,
                howmuchforreseller: configurations.howmuchforreseller,
                howmuchtimeforeditpassworddays: configurations.howmuchtimeforeditpassworddays,
                canrecoverpassword: configurations.canrecoverpassword
            }

            if (JSON.stringify(configuration) !== JSON.stringify(configcurrent)) {
                configuration.sliders = configurations.sliders
                const formData = new FormData();
                formData.append('data', JSON.stringify(configuration));
                formData.append('current', JSON.stringify(configurations));

                formData.append('rawDataYape', JSON.stringify(convertToRaw(yapeEditor.getCurrentContent())));
                formData.append('rawDataPlin', JSON.stringify(convertToRaw(plinEditor.getCurrentContent())));
                formData.append('rawDataPagomovil', JSON.stringify(convertToRaw(pagomovilEditor.getCurrentContent())));
                formData.append('rawDataNequi', JSON.stringify(convertToRaw(nequiEditor.getCurrentContent())));
                formData.append('rawDataBanamex', JSON.stringify(convertToRaw(banamexEditor.getCurrentContent())));
                formData.append('rawDataYolopago', JSON.stringify(convertToRaw(yolopagoEditor.getCurrentContent())));
                formData.append('rawDataTigomoney', JSON.stringify(convertToRaw(tigomoneyEditor.getCurrentContent())));
                formData.append('rawDataYasta', JSON.stringify(convertToRaw(yastaEditor.getCurrentContent())));
                formData.append('rawDataTransferencia', JSON.stringify(convertToRaw(transferenciaEditor.getCurrentContent())));
                formData.append('rawDataSpin', JSON.stringify(convertToRaw(spinEditor.getCurrentContent())));
                formData.append('rawDataCashapp', JSON.stringify(convertToRaw(cashappEditor.getCurrentContent())));
                formData.append('rawDataVenmo', JSON.stringify(convertToRaw(venmoEditor.getCurrentContent())));
                formData.append('rawDataZelle', JSON.stringify(convertToRaw(zelleEditor.getCurrentContent())));
                formData.append('rawDataIzipay', JSON.stringify(convertToRaw(izipayEditor.getCurrentContent())));
                formData.append('rawDataMercadopago', JSON.stringify(convertToRaw(mercadopagoEditor.getCurrentContent())));
                formData.append('rawDataBinance', JSON.stringify(convertToRaw(binanceEditor.getCurrentContent())));
                formData.append('rawDataPaypal', JSON.stringify(convertToRaw(paypalEditor.getCurrentContent())));
                formData.append('rawDataStripe', JSON.stringify(convertToRaw(stripeEditor.getCurrentContent())));

                formData.append('image1', configuration.logo)
                formData.append('image2', configuration.slider1)
                formData.append('image3', configuration.slider2)
                formData.append('image4', configuration.slider3)
                formData.append('image5', configuration.slider4)
                formData.append('image6', configuration.slider5)
                formData.append('image7', configuration.qryape);
                formData.append('image8', configuration.qrplin);
                formData.append('image9', configuration.qrpagomovil);
                formData.append('image10', configuration.qrnequi);
                formData.append('image11', configuration.qrbanamex);
                formData.append('image12', configuration.qryolopago);
                formData.append('image13', configuration.qrtigomoney);
                formData.append('image14', configuration.qryasta);
                formData.append('image15', configuration.qrtransferencia);
                formData.append('image16', configuration.qrspin);
                formData.append('image17', configuration.qrcashapp);
                formData.append('image18', configuration.qrvenmo);
                formData.append('image19', configuration.qrzelle);
                formData.append('image20', configuration.qrizipay);
                formData.append('image21', configuration.qrmercadopago);
                formData.append('image22', configuration.qrbinance);
                formData.append('image23', configuration.qrpaypal);
                formData.append('image24', configuration.qrstripe);
                dispatch(updateConfiguration(formData))
            } else {
                message('No hubo ningún cambio.', 'error', 4)
            }

        } else {
            errors.map((err) => {
                message(err.message, 'error', 4)
            });
        }

    }

    useEffect(() => {
        if (isMutation.updated) {
            message(isMutation.message, 'success', 5)
            Socket.emit('uConfiguration', { newConfiguration: isMutation.extra.newConfiguration })
            setPreview({ ...preview, logo: '', slider1: '', slider2: '', slider3: '', slider4: '', slider5: '' })
            setConfiguration({ ...configuration, logo: '', slider1: '', slider2: '', slider3: '', slider4: '', slider5: '' })
            dispatch(SET_TO_DEFAULT_RESPONSE())
        }
    }, [isMutation.updated])

    return (
        <Wrapper>
            {/* HEADER PAGES */}
            <div className="fixed ml-7 md:ml-0 pl-3 md:pl-3 lg:pl-3 h-8 top-2 md:top-11 z-30 flex items-center w-full md:w-8/12 text-brand-900 dark:text-brand-100 text-[1.2rem] md:text-[1.8rem] lg:text-[2rem] font-semibold">
                Gestionar Whatsapp BOT
            </div>

            <div className="flex flex-wrap mt-24 gap-4">
                <WhatsAppQRCode />
            </div>
        </Wrapper >
    )
}
export default WhatsAppBot;